"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ContentService2 = _interopRequireDefault(require("../ContentService"));

var _Device = _interopRequireDefault(require("../../models/compatibility-guide/Device"));

var _ParamsValidator = _interopRequireDefault(require("../../validators/ParamsValidator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var DeviceContentService =
/*#__PURE__*/
function (_ContentService) {
  _inherits(DeviceContentService, _ContentService);

  function DeviceContentService() {
    var _this;

    _classCallCheck(this, DeviceContentService);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DeviceContentService).call(this));

    _this.parse = function (result) {
      if (result instanceof Array) {
        var parsedResult = [];
        result.forEach(function (item) {
          var device = new _Device["default"]();
          Object.keys(item).forEach(function (key) {
            device[key] = item[key];
          });
          parsedResult.push(device);
        });
        return parsedResult;
      }

      return null;
    };

    _this.verifyParams = function () {
      return _ParamsValidator["default"].isValid(_this.params, {
        ProductId: {
          required: false,
          type: 'int'
        },
        Market: {
          required: false
        },
        IncludeExternalDevices: {
          required: false
        }
      });
    };

    return _this;
  }

  return DeviceContentService;
}(_ContentService2["default"]);

var _default = DeviceContentService;
exports["default"] = _default;